import React from 'react';
import { Route } from 'react-router-dom';

interface PublicRouteProps {
  layout: any;
  exact?: any;
  path: string;
}

const PublicRoute = ({ layout: Layout, ...rest }: PublicRouteProps) => (
  <Route {...rest} render={props => <Layout {...props} />} />
);

export default PublicRoute;
